import React from 'react';
import { DropdownItem, NavItem } from 'reactstrap';
import { NavLink as Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface IMenuItem {
  children: React.ReactNode;
  icon: IconProp | null;
  to: string;
  id?: string;
  'data-cy'?: string;
}

const MenuItem = (props: IMenuItem) => {
  const { to, icon, id, children } = props;
  return (
    <NavItem tag={Link} to={to} id={id} data-cy={props['data-cy']} className={'navigation-item'}>
      {icon && <FontAwesomeIcon icon={icon} fixedWidth />} {children}
    </NavItem>
  );
};

export const MenuItemDropDownDown = (props: IMenuItem) => {
  const { to, icon, id, children } = props;

  return (
    <DropdownItem tag={Link} to={to} id={id} data-cy={props['data-cy']}>
      {icon && <FontAwesomeIcon icon={icon} fixedWidth />}
      {children}
    </DropdownItem>
  );
};

export default MenuItem;
